import React from 'react';
import { graphql, useStaticQuery } from 'gatsby';

// import components
import ProgramFeaturesItem from './ProgramFeaturesItem';

// import styled components
import { Grid } from '../styled';
import { ProgramFeaturesWrapper } from './styled';

// import svg
import OfferingOptionsIcon from '../../svgs/offering-options-icon.svg';
import AvailableForIcon from '../../svgs/available-for-icon.svg';
import TeamOfIcon from '../../svgs/team-of-icon.svg';
import PortfolioFinancingIcon from '../../svgs/portfolio-financing-icon.svg';

const iconsMap = {
  AvailableForIcon: AvailableForIcon,
  OfferingOptionsIcon: OfferingOptionsIcon,
  TeamOfIcon: TeamOfIcon,
  PortfolioFinancingIcon: PortfolioFinancingIcon,
};

const ProgramFeatures = () => {
  const {
    allProgramFeaturesJson: { nodes },
  } = useStaticQuery(graphql`
    query {
      allProgramFeaturesJson {
        nodes {
          title
          icon
        }
      }
    }
  `);

  return (
    <ProgramFeaturesWrapper aria-label="Condotel financing program features">
      <Grid>
        <h1>Condotel Financing Program Features</h1>
        {nodes.map(node => (
          <ProgramFeaturesItem
            key={node.title}
            Icon={iconsMap[node.icon]}
            title={node.title}
          />
        ))}
      </Grid>
    </ProgramFeaturesWrapper>
  );
};

export default ProgramFeatures;
